<template>
    <svg
        width="660"
        height="389"
        viewBox="0 0 660 389"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
    >
        <text
            fill="var(--et-colors-text)"
            xml:space="preserve"
            style="white-space: pre"
            font-family="Geist"
            font-size="36"
            font-weight="600"
            letter-spacing="-1px"
        >
            <tspan x="233.326" y="58.2">Wall of love</tspan>
        </text>
        <text
            fill="var(--et-colors-text)"
            xml:space="preserve"
            style="white-space: pre; opacity: 0.8"
            font-family="Geist"
            font-size="16"
            letter-spacing="0em"
        >
            <tspan x="242" y="90.2">Our customers&#39; reviews.</tspan>
        </text>
        <path
            d="M48 145C48 138.373 53.3726 133 60 133H600C606.627 133 612 138.373 612 145V377C612 383.627 606.627 389 600 389H60C53.3726 389 48 383.627 48 377V145Z"
            fill="var(--et-colors-card-background)"
            stroke="var(--et-colors-border)"
        />
        <path
            d="M288.554 157.519C288.845 156.827 289.837 156.827 290.128 157.519L291.847 161.601C291.97 161.892 292.247 162.091 292.566 162.117L297.026 162.47C297.782 162.53 298.089 163.461 297.513 163.949L294.114 166.825C293.872 167.03 293.765 167.353 293.84 167.66L294.878 171.96C295.054 172.688 294.252 173.264 293.605 172.874L289.786 170.569C289.513 170.405 289.17 170.405 288.897 170.569L285.078 172.874C284.431 173.264 283.629 172.688 283.805 171.96L284.843 167.66C284.917 167.353 284.811 167.03 284.568 166.825L281.17 163.949C280.594 163.461 280.9 162.53 281.656 162.47L286.117 162.117C286.435 162.091 286.713 161.892 286.836 161.601L288.554 157.519Z"
            fill="#F4C546"
        />
        <path
            d="M308.884 157.519C309.175 156.827 310.167 156.827 310.458 157.519L312.176 161.601C312.299 161.892 312.577 162.091 312.895 162.117L317.356 162.47C318.111 162.53 318.418 163.461 317.842 163.949L314.444 166.825C314.201 167.03 314.095 167.353 314.169 167.66L315.207 171.96C315.383 172.688 314.581 173.264 313.934 172.874L310.115 170.569C309.842 170.405 309.499 170.405 309.226 170.569L305.407 172.874C304.76 173.264 303.958 172.688 304.134 171.96L305.172 167.66C305.246 167.353 305.14 167.03 304.898 166.825L301.499 163.949C300.923 163.461 301.23 162.53 301.986 162.47L306.446 162.117C306.765 162.091 307.042 161.892 307.165 161.601L308.884 157.519Z"
            fill="#F4C546"
        />
        <path
            d="M329.213 157.519C329.504 156.827 330.496 156.827 330.787 157.519L332.506 161.601C332.628 161.892 332.906 162.091 333.224 162.117L337.685 162.47C338.441 162.53 338.747 163.461 338.171 163.949L334.773 166.825C334.53 167.03 334.424 167.353 334.498 167.66L335.537 171.96C335.713 172.688 334.91 173.264 334.263 172.874L330.444 170.569C330.172 170.405 329.828 170.405 329.556 170.569L325.737 172.874C325.09 173.264 324.287 172.688 324.463 171.96L325.502 167.66C325.576 167.353 325.47 167.03 325.227 166.825L321.828 163.949C321.253 163.461 321.559 162.53 322.315 162.47L326.776 162.117C327.094 162.091 327.372 161.892 327.494 161.601L329.213 157.519Z"
            fill="#F4C546"
        />
        <path
            d="M349.542 157.519C349.833 156.827 350.825 156.827 351.116 157.519L352.835 161.601C352.958 161.892 353.235 162.091 353.554 162.117L358.014 162.47C358.77 162.53 359.077 163.461 358.501 163.949L355.102 166.825C354.86 167.03 354.754 167.353 354.828 167.66L355.866 171.96C356.042 172.688 355.24 173.264 354.593 172.874L350.774 170.569C350.501 170.405 350.158 170.405 349.885 170.569L346.066 172.874C345.419 173.264 344.617 172.688 344.793 171.96L345.831 167.66C345.905 167.353 345.799 167.03 345.556 166.825L342.158 163.949C341.582 163.461 341.888 162.53 342.644 162.47L347.105 162.117C347.424 162.091 347.701 161.892 347.824 161.601L349.542 157.519Z"
            fill="#F4C546"
        />
        <path
            d="M369.872 157.519C370.163 156.827 371.155 156.827 371.446 157.519L373.164 161.601C373.287 161.892 373.565 162.091 373.883 162.117L378.344 162.47C379.1 162.53 379.406 163.461 378.83 163.949L375.432 166.825C375.189 167.03 375.083 167.353 375.157 167.66L376.195 171.96C376.371 172.688 375.569 173.264 374.922 172.874L371.103 170.569C370.83 170.405 370.487 170.405 370.214 170.569L366.395 172.874C365.748 173.264 364.946 172.688 365.122 171.96L366.16 167.66C366.234 167.353 366.128 167.03 365.886 166.825L362.487 163.949C361.911 163.461 362.218 162.53 362.974 162.47L367.434 162.117C367.753 162.091 368.03 161.892 368.153 161.601L369.872 157.519Z"
            fill="#F4C546"
        />
        <path
            d="M582 189H78C74.6863 189 72 191.686 72 195C72 198.314 74.6863 201 78 201H582C585.314 201 588 198.314 588 195C588 191.686 585.314 189 582 189Z"
            fill="#8799B5"
            style="opacity: 0.15"
        />
        <path
            d="M534 209H126C122.686 209 120 211.686 120 215C120 218.314 122.686 221 126 221H534C537.314 221 540 218.314 540 215C540 211.686 537.314 209 534 209Z"
            fill="#8799B5"
            style="opacity: 0.15"
        />
        <path
            d="M544 229H116C112.686 229 110 231.686 110 235C110 238.314 112.686 241 116 241H544C547.314 241 550 238.314 550 235C550 231.686 547.314 229 544 229Z"
            fill="#8799B5"
            style="opacity: 0.15"
        />
        <path
            d="M495 249H165C161.686 249 159 251.686 159 255C159 258.314 161.686 261 165 261H495C498.314 261 501 258.314 501 255C501 251.686 498.314 249 495 249Z"
            fill="#8799B5"
            style="opacity: 0.15"
        />
        <path
            d="M330 318.125C341.115 318.125 350.125 309.115 350.125 298C350.125 286.885 341.115 277.875 330 277.875C318.885 277.875 309.875 286.885 309.875 298C309.875 309.115 318.885 318.125 330 318.125Z"
            fill="#F2F4F7"
            stroke="white"
            stroke-width="1.75"
        />
        <path
            d="M324 303.833C325.557 302.182 327.671 301.167 330 301.167C332.329 301.167 334.443 302.182 336 303.833M333 295.5C333 297.157 331.657 298.5 330 298.5C328.343 298.5 327 297.157 327 295.5C327 293.843 328.343 292.5 330 292.5C331.657 292.5 333 293.843 333 295.5Z"
            stroke="#101828"
            stroke-linecap="round"
            stroke-linejoin="round"
        />
        <text
            fill="var(--et-colors-card-text)"
            xml:space="preserve"
            style="white-space: pre"
            font-family="Geist"
            font-size="14"
            font-weight="500"
            letter-spacing="0em"
        >
            <tspan x="281" y="340.8">Leslie Spencer</tspan>
        </text>
        <text
            fill="var(--et-colors-card-text)"
            xml:space="preserve"
            style="white-space: pre; opacity: 0.8"
            font-family="Geist"
            font-size="12"
            letter-spacing="0em"
        >
            <tspan x="282.5" y="360.4">Junior Developer</tspan>
        </text>
        <path
            d="M27 255L21 261L27 267M633 267L639 261L633 255"
            stroke="#667085"
            stroke-width="1.5"
            stroke-linecap="round"
            stroke-linejoin="round"
        />
    </svg>
</template>
<script setup lang="ts"></script>
